define('constants/permissionInheritanceConstants',[], function() {
    return {
        enabled: "enabled",
        disabled: "disabled"
    };
});
